import {NgModule} from '@angular/core';
import {ExamFormSaveModule} from './impl/page/exam-form-save/exam-form-save.module';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ExamFormDataService} from './impl/service/ngrx/examFormData.service';
import {ExamFormDataServiceAdapter} from './impl/service/ngrx/examFormDataService.adapter';
import {ExamFormRepository} from './impl/service/ngrx/examForm.repository';
import {ExamFormConverter} from './api/converter/examForm.converter';
import {ExamFormSummaryDataServiceAdapter} from './impl/service/ngrx/examFormSummaryDataService.adapter';
import {ExamFormSummaryConverter} from './api/converter/examFormSummary.converter';
@NgModule({
    imports: [ExamFormSaveModule],
    providers: [
        ExamFormDataService,
        ExamFormDataServiceAdapter,
        ExamFormSummaryDataServiceAdapter,
        ExamFormRepository,
        ExamFormConverter,
        ExamFormSummaryConverter,
    ]
})
export class ExamFormModule {

    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ExamFormDataService,
                service: ExamFormRepository,
    ) {

        entityDataService.registerServices({
            'ExamForm': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'ExamForm': service,
        });
    }
}
